import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import {
  CreateAudioTracksModal,
  EditAudioFileModal,
  AudioFileListFilters
} from "@modules/audioFiles/components";
import { CsvExportButton, FilterDropdown } from "@shared/components";

import {  useAudioFileList } from "./controller";
import { useAudioFileListColumns } from "./columns";

export const AudioFileList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    books,
    selectedRows,
    dataToExport,
    createAudioFileModalRef,
    editAudioFileModalRef,
    setSelectedRows,
    refetch,
    translate,
  } =  useAudioFileList();

  const columns = useAudioFileListColumns(refetch, translate, editAudioFileModalRef, books);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <AudioFileListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="audiofiles.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createAudioFileModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateAudioTracksModal
        modalRef={createAudioFileModalRef}
        onComplete={refetch}
      />

      <EditAudioFileModal
        modalRef={editAudioFileModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
